module.exports = __webpack_public_path__ + "static/img/3.a310ca0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/eng/3.png
// module id = eodZ
// module chunks = 0